import InstagramGreyIcon from './InstagramGreyIcon';
export default InstagramGreyIcon;
